// extracted by mini-css-extract-plugin
export default {"card":"Card_card__RkTGj","card_title":"Card_card_title__S0sxQ","icon":"Card_icon__kfoL-","ques":"Card_ques__11Vi8","card_desc":"Card_card_desc__eh-XJ"};